<template>
    <v-container class ="mt-16">
         <!-- Edit/Create Appraiser Dialog -->
    <v-dialog v-model="editDialog" max-width="600px">
    <v-card>
        <v-card-title>
          {{ appraiserFormData.id ? `Edit Appraiser : ${appraiserFormData.name}` : 'New Appraiser' }}
          <v-spacer></v-spacer>
          <v-switch 
            v-if="!appraiserFormData.id "
            v-model="multipleMode" 
            label="Multiple Selection Mode" 
          ></v-switch>
          <v-btn icon                    
          @click="consoletest()">
          <v-icon > mdi-user</v-icon>
          </v-btn> 
        </v-card-title>
        <v-card-text>
            <v-form ref="editForm" v-model="editformvalid">
                <!-- <v-text-field 
                v-if = appraiserFormData.id 
                v-model="appraiserFormData.name"
                label="Appraiser Name"
                :rules="[v => !!v || 'Name is required']"
                required
                disabled
                ></v-text-field> -->
                <v-autocomplete
                v-if="!appraiserFormData.id"
                v-model="appraiserFormData.appraisers"
                :items="availableAppraisers"
                :label="multipleMode ? 'Appraisers' : 'Appraiser'"
                :rules="[v => !!v || 'Appraiser is required']"
                required
                return-object
                :multiple="multipleMode"
                chips
                item-text="name" 
                item-value="id"
                >
                <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                    <!-- Use employee photo if available, otherwise use mdi-account icon as the avatar -->
                    <v-img v-if="item.EMPMST_PHOTO" :src="item.EMPMST_PHOTO"></v-img>
                    <v-icon v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.designation"></v-list-item-subtitle>
                    </v-list-item-content>
                </template>
                <!-- <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    @click:close="removeAppraiser(item)"
                    >
                    <strong>{{ item.name }}</strong>
                    </v-chip>
                </template> -->
                <template v-slot:no-data>
                    <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>No Data Available - <span @click="getAllEmployees(true)" style="color: blue; cursor:pointer;">Search on Server</span></v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                </template>
                </v-autocomplete>

                <!-- Combobox for appraisees -->
                <v-combobox
                v-model="appraiserFormData.appraisees"
                :items="availableAppraisees"
                item-text="name"
                item-value="id"
                label="Select Appraisees"
                multiple
                chips
                clearable
                prepend-icon="mdi-account-group-outline"
                solo
                >
                <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    :close="!item.isAppraised"
                    @click="selectAppraisee(item)"
                    :disabled="item.isAppraised"
                    @click:close="removeAppraisee(item)"
                    >
                    <!-- <strong>{{ item.name }}</strong> -->
                    <v-avatar
                        v-if="item.name"
                        class="accent white--text"
                        left
                        v-text="item.name.slice(0, 1).toUpperCase()"
                    ></v-avatar>
                    {{ item.name }}
                    </v-chip>
                </template>
                <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                    <!-- Use employee photo if available, otherwise use mdi-account icon as the avatar -->
                    <v-img v-if="item.EMPMST_PHOTO" :src="item.EMPMST_PHOTO"></v-img>
                    <v-icon v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.id"></v-list-item-subtitle>
                    </v-list-item-content>
                </template>
                <template v-slot:no-data>
                    <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                        No Data Available - 
                        <span @click="getAllEmployees(refresh = true)" style="color: blue; cursor:pointer;">Search on Server</span>
                        </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                </template>
                </v-combobox>   
                <v-list>
                <v-list-item v-for="appraisee in appraiserFormData.appraisees" :key="appraisee.id">
                <v-list-item-content>
                    <v-list-item-title>{{ appraisee.name }} ({{ appraisee.empCode }})</v-list-item-title>
                    <v-list-item-subtitle>{{ appraisee.department }}, {{ appraisee.designation }}, {{ appraisee.company }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action >
                    <v-btn 
                    icon 
                    color="red"
                    :disabled ="appraisee.isAppraised"
                    @click="deleteAppraisee(appraisee.id)">
                    <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-list-item-action>
                </v-list-item>            
            </v-list>           
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-switch          
            v-model="autoUpdate"
            label="Auto Update"
            ></v-switch>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeEdit">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="saveEdit">Save</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>

    </v-container>
</template>
<script>
import dynamic_axios from "../services/dynamic_axios";

export default {
  data() {
    return {
      detailsDialog: false,
      multipleMode: false,
      autoUpdate: false,
      selectedAppraiser: {},
      editDialog: true,
      appraiserFormData: {
        id: null,
        name: '',
        empCode: '',
        designation: '',
        department: '',
        company: '',
        appraisers: [],
        appraisees: [] // This will hold the IDs of the selected appraisees
      },
      isUpdating: false,
      editformvalid: true,
      skymatEmployees:[],
      tritonEmployees: [],
      // allEmployees: [],
      isloadingEmployees: false,
      headers: [
        { text: 'Sl No.', value: 'slno' },
        { text: 'Appraiser Name', value: 'name' },
        { text: 'Appraiser Code', value: 'empCode' },
        { text: 'Appraiser Designation', value: 'designation' },
        { text: 'Appraiser Department', value: 'department' },
        { text: 'Appraiser Company', value: 'company' },
        { text: 'Appraisees', value: 'appraisees' },
        { text: 'Action', value: 'action', sortable: false }
      ],
      appraisers: [
          {
              id: 1, slno: 1, name: 'John Doe', empCode: 'EMP001', designation: 'Manager', department: 'HR', company: 'Skymat',
              appraisees: [
              { id: 101, name: 'Alice Smith', empCode: 'EMP102', department: 'Marketing', designation: 'Specialist', company: 'Skymat' , isAppraised:false},
              { id: 102, name: 'Bob Johnson', empCode: 'EMP103', department: 'Sales', designation: 'Associate', company: 'Triton',isAppraised:true },
              { id: 103, name: 'Charlie Lee', empCode: 'EMP104', department: 'Finance', designation: 'Analyst', company: 'Skymat',isAppraised:true }
            ]
          },
          {
              id: 2, slno: 2, name: 'Emily Roe', empCode: 'EMP002', designation: 'Director', department: 'Finance', company: 'Triton',
              appraisees: [
              { id: 103, name: 'Charlie Lee', empCode: 'EMP104', department: 'Finance', designation: 'Analyst', company: 'Skymat' },
              { id: 104, name: 'Dana Kay', empCode: 'EMP105', department: 'IT', designation: 'Developer', company: 'Triton' }
              ]
          },
      ],
      pendingAdditions: [],
      pendingDeletions: [],
    };
  },
  computed: {   
    user() {     
      return this.$store.getters.factsuser;      
    },
    userProfile(){
      return this.$store.getters.userProfile;
    },
    perferedAPI() {
      return this.$store.getters.perferedAPI;
    }, 
    isMobile() {
      return window.innerWidth <= 600; // or whatever threshold you like
    },
    appraisersModel: {
      get() {
        // Return first element if in single mode, or full array if in multiple mode
        return this.multipleMode ? this.appraiserFormData.appraisers : (this.appraiserFormData.appraisers[0] || null);
      },
      set(value) {
        // Set the whole array in multiple mode or wrap the single object in an array if in single mode
        this.appraiserFormData.appraisers = this.multipleMode ? value : [value];
      }
    },
    // Combine and organize employees by company and department
    // allEmployees() {
    //   return [...this.skymatEmployees, ...this.tritonEmployees]
    //   .filter(emp => emp.EMPMST_DOCUMENT_STATUS_DOCNO === "ACT") 
    //   .map(emp => ({
    //       ...emp,        
    //       group: `${emp.company} - ${emp.department}`, // Add a group property for grouping in the autocomplete
    //   }));
    // },
    
    availableAppraisers() {
      // Gather IDs from appraiserFormData.appraisees
      let appraiseeIds = this.appraiserFormData.appraisees.map(appraisee => appraisee.id);
      // Gather IDs from the general appraisers list
      let appraiserIds = this.appraisers.map(appraiser => appraiser.id);

      return this.allEmployees.filter(emp => {
        // Check if the employee is not marked as an appraiser
        return !emp.isAppraiser
          // And is not already selected as an appraisee
          && !appraiseeIds.includes(emp.id)
          // And is not already listed in appraisers
          && !appraiserIds.includes(emp.id);
      });
    },
    availableAppraisees() {
      // Exclude the current appraiser and ensure no appraiser is selected as an appraisee
      const currentAppraiserId = this.appraiserFormData.id;
      return this.allEmployees.filter(emp => emp.id !== currentAppraiserId && !emp.isAppraiser);
    },
  },
  watch:{
    skymatEmployees:{
      handler(){
        this.updateAllEmployees();
      },
      immediate:true
    },
    tritonEmployees:{
      handler(){
        this.updateAllEmployees();
      },
      immmediate:true
    },
    appraiserFormData: {
      handler() {
        // Reset pending changes when the main form data changes
        this.pendingAdditions = [];
        this.pendingDeletions = [];
      },
      deep: true
    }
  },
  methods: {   
    consoletest(){
      console.log("appraisers",this.appraisers)
      // console.log("availableAppraisees:" , this.availableAppraisees)
      // console.log("availableAppraisers:" , this.availableAppraisers)
      // console.log("TritonEmployees:" , this.tritonEmployees)
      // console.log("SkymatEmployees:" , this.skymatEmployees)
    },
    async getEmployees(company) {
      this.isLoadingEmployees = true;  // Start loading state

      try {
        // Extracting user details safely
        const employ_id = this.user.USER_EMP_DOCNO;
        const EMPMST_DESG_DOCNO = this.userProfile.EMPMST_DESG_DOCNO;
        const dep = this.userProfile.EMPMST_UD_TXT5;
        const USER_LOGINID = this.user.USER_LOGINID;
        const purpose='appraise_assign'

        // Constructing the query string
        const params = new URLSearchParams({
          employ_id,
          EMPMST_DESG_DOCNO,
          dep,
          USER_LOGINID,
          purpose
        }).toString();

        const response = await dynamic_axios.get(`employees?${params}`, {
          apiName: company  // Specify which API configuration to use
        });
        console.log( response.data.employees)
        const employees = response.data.employees
        .filter(emp => emp.EMPMST_DOCUMENT_STATUS_DOCNO === "ACT")
        .map(emp => ({
          id: emp.EMPMST_DOCNO,
          name: emp.EMPMST_NAME,
          empCode: emp.EMPMST_DOCNO,
          designation: emp.DESIG_DESC,
          department:emp.PDEPTMST_DESC,
          company: company,
          EMPMST_PHOTO:emp.EMPMST_PHOTO,
          isAppraiser: emp.isAppraiser || false
        }));

        if (company === 'skymat') {
          this.skymatEmployees = employees;
        } else if (company === 'triton') {
          this.tritonEmployees = employees;
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
        this.isLoadingEmployees = false;  // End loading state
      }
    },
    async getAllEmployees(refresh = false){
      if (refresh){
        await this.$store.dispatch("get_employee", { employ_id: this.user.USER_EMP_DOCNO})
        await Promise.all([
          this.getEmployees('triton'),
          this.getEmployees('skymat')
        ])
      } else {
        // Only fetch if arrays are undefined or empty
        if (!this.skymatEmployees.length) {
          await this.getEmployees('skymat');
        }
        if (!this.tritonEmployees.length) {
          await this.getEmployees('triton');
        }
      }
    },
    updateAllEmployees(){
      this.allEmployees = [
        ...this.skymatEmployees,
        ...this.tritonEmployees]        
        .map(emp => ({
          ...emp,
          group: `${emp.company} - ${emp.department}`
        })
      );
    },
    openViewModal(appraiser) {
        this.selectedAppraiser = appraiser;
        this.detailsDialog = true;
    },
    async getAppraisers(company){
      this.isLoadingEmployees = true;
      if (!company)
        company= this.user?.company;
      try{
        const response = await dynamic_axios.get('/appraisal/appraisers', {
          apiName: company  // Specify which API configuration to use
        });

        const appraisers = response.data.appraisers
        // .map(appr => ({
        //   id: appr.appr_id,
        //   name: appr.appr_name,
        //   empCode: appr.appr_code,
        //   designation: appr.DESIG_DESC,
        //   department:appr.appr_department,
        //   appraisees:appr.appraisees,
        // }));

        if (company === 'skymat') {
          this.skymatApraisers = appraisers;
        } else if (company === 'triton') {
          this.tritonApraisers = appraisers;
        }
      } catch (error) {
        console.error("Error fetching Appraisers:", error);
      } finally {
        this.isLoadingEmployees = false;  // End loading state
      }

    },
    async deleteAppraiser(appraiserId) {
      try {
        await dynamic_axios.delete('/appraisal/appraiser', {
          user_id: 'currentUserId',
          appraisee_ids: [appraiserId]
        }, {
          apiName: 'companyName'
        });
        this.appraisers = this.appraisers.filter(a => a.id !== appraiserId);
        this.$toast.success('Appraisee deleted successfully!');
      } catch (error) {
        console.error('Failed to delete appraisee:', error);
        this.$toast.error('Failed to delete appraisee.');
      }
    },
    openEditDialog(appraiser = null) {          
      if (appraiser) {
        this.multipleMode=false;
        this.appraiserFormData = JSON.parse(JSON.stringify(appraiser));
        // Ensure all potentially undefined properties are initialized
        this.appraiserFormData.appraisers = this.appraiserFormData.appraisers || [];
        this.appraiserFormData.appraisees = this.appraiserFormData.appraisees || [];
      } else {
          this.resetappraiserFormData(); // Reset to default structure
      }
      this.editDialog = true;
    },
    removeAppraiser(item) {
      if (this.multipleMode) {
        this.appraiserFormData.appraisers = this.appraiserFormData.appraisers.filter(a => a.id !== item.id);
      } else {
        this.appraiserFormData.appraisers = [];
      }
    },    
    addAppraiseeToAppraiser(appraiserId, newAppraisee) {
      const appraiserIndex = this.appraisers.findIndex(appraiser => appraiser.id === appraiserId);
      if (appraiserIndex === -1) {
        console.error('Appraiser not found');
        return;
      }

      // Clone, modify, and replace the appraisees array to maintain reactivity
      const newAppraisees = [...this.appraisers[appraiserIndex].appraisees, newAppraisee];
      this.$set(this.appraisers[appraiserIndex], 'appraisees', newAppraisees);

      console.log('Appraisees after addition:', this.appraisers[appraiserIndex].appraisees);
    },
    removeAppraiseeFromAppraiser(appraiserId, appraiseeId) {
      const appraiserIndex = this.appraisers.findIndex(appraiser => appraiser.id === appraiserId);
      if (appraiserIndex === -1) {
        console.error('Appraiser not found');
        return;
      }

      // Find the appraisee and remove it from the array
      const appraisees = this.appraisers[appraiserIndex].appraisees;
      const appraiseeIndex = appraisees.findIndex(appraisee => appraisee.id === appraiseeId);
      if (appraiseeIndex === -1) {
        console.error('Appraisee not found');
        return;
      }

      // Create a new array without the appraisee
      const newAppraisees = [...appraisees.slice(0, appraiseeIndex), ...appraisees.slice(appraiseeIndex + 1)];
      this.$set(this.appraisers[appraiserIndex], 'appraisees', newAppraisees);

      console.log('Appraisees after removal:', this.appraisers[appraiserIndex].appraisees);
    },
    // addAppraisee(newAppraisee) {
    //     newAppraisee.tempId = this.nextTempId++; // Assign a temporary ID
    //     this.appraiserFormData.appraisees.push(newAppraisee);
    // },
    // removeAppraisee(appraisee) {
    //   if (!appraisee.isAppraised) {
    //     const index = this.appraiserFormData.appraisees.findIndex(a => a.id === appraisee.id);
    //     if (index > -1) {
    //       this.appraiserFormData.appraisees.splice(index, 1);
    //     }
    //   } else {
    //   // Optionally, provide feedback that the appraisee cannot be removed
    //   console.log("Cannot remove appraised appraisee.");
    // }
    // },
    getNextId() {
      return this.appraisers.length > 0 ? Math.max(...this.appraisers.map(a => a.id)) + 1 : 1;
    },
    getNextSlNo() {
      return this.appraisers.length + 1;
    },
    resetappraiserFormData() {
      this.appraiserFormData = {
        id: null,        
        name: '',
        empCode: '',
        designation: '',
        department: '',
        company: '',
        appraisers: [],
        appraisees: []
      };
    },
    saveEdit() {
      if (this.$refs.editForm.validate()) {
        let appraisersToAdd;
        if (this.multipleMode) {
          // If multiple selection mode, process each appraiser in the array
          appraisersToAdd = this.appraiserFormData.appraisers.map(appraiser => ({
              id: appraiser.id || this.getNextId(),
              slno: appraiser.slno || this.getNextSlNo(),
              appr_emp_name: appraiser.name,
              appr_emp_code: appraiser.empCode,
              appr_designation: appraiser.designation,
              appr_department: appraiser.department,
              appr_company: appraiser.company,
              appraisees: this.appraiserFormData.appraisees.map(appraisee => ({
                  ...appraisee,
                  
              }))
          }));
        } else {
          // If single selection mode, process the single appraiser object
          appraisersToAdd = [{
            id: this.appraiserFormData.appraisers.id || this.getNextId(),
            slno: this.appraiserFormData.appraisers.slno || this.getNextSlNo(),
            appr_emp_name: this.appraiserFormData.appraisers.name,
            appr_emp_code: this.appraiserFormData.appraisers.empCode,
            appr_designation: this.appraiserFormData.appraisers.designation,
            appr_department: this.appraiserFormData.appraisers.department,
            appr_company: this.appraiserFormData.appraisers.company,
            appraisees: this.appraiserFormData.appraisees.map(appraisee => ({
              ...appraisee,
              isAppraised: false
            }))
          }];
        }

        // Handle updating or adding new appraisers
        // if (this.appraiserFormData.id) {
        //   console.log('Attempting to update with ID:', this.appraiserFormData.id);
        //   appraisersToAdd.forEach(newAppraiser => {
        //     const index = this.appraisers.findIndex(a => a.id === newAppraiser.id);
        //     console.log('Index found:', index);
        //     if (index !== -1) {
        //         this.appraisers[index] = newAppraiser;
        //         console.log('Updated appraiser:', this.appraisers[index]);
        //     }
        //   });
        // } 
        let appraiserIndex = -1;
      if (this.appraiserFormData.id) {
        appraiserIndex = this.appraisers.findIndex(a => a.id === this.appraiserFormData.id);
      }

      if (appraiserIndex !== -1) {
        // Update existing appraiser and appraisees
        this.updateAppraisees(this.appraiserFormData.id);
        this.appraisers[appraiserIndex] = {...this.appraisers[appraiserIndex], ...this.appraiserFormData};
      }
        else {
            // Add new appraisers
            this.appraisers.push(...appraisersToAdd);
        }

        this.editDialog = false;
        this.resetappraiserFormData(); // Clear form after saving
      }
    }, 
    closeEdit() {
      this.appraiserFormData= {
        id: null,
        name: '',
        empCode: '',
        designation: '',
        department: '',
        company: '',
        appraisers: [],
        appraisees: [] // This will hold the IDs of the selected appraisees
      },
      this.editDialog = false;
    },    
    closeDetailDialog() {
      this.selectedAppraiser = {},
      this.detailsDialog = false;
    },
    getChipRows(appraisees) {
      const maxChips = 5;
      return [
          appraisees.slice(0, maxChips),
          ...(appraisees.length > maxChips ? [appraisees.slice(maxChips)] : [])
      ];
    },
    queueAddition(appraisee) {
      this.pendingAdditions.push({
        employee_code: appraisee.empCode,
        employee_name: appraisee.name,
        reporting_to: appraisee.reportingTo || '',
        company: appraisee.company,
        department: appraisee.department,
        designation: appraisee.designation,
        employee_uid: appraisee.uid || '',
      });
      // this.$toast.info('Appraisee queued for addition.');
    },
    queueDeletion(appraiseeId) {
      this.pendingDeletions.push(appraiseeId);
      // this.$toast.info('Appraisee queued for deletion.');
    },
    selectAppraisee(appraisee) {
      if (this.autoUpdate) {
        // If autoUpdate is true, send the add request immediately
        this.addAppraisee([appraisee]);  // Adjusted to handle a list of one for consistency
      } else {
        // Otherwise, queue the addition
        this.queueAddition(appraisee);
        this.$toast.info('Appraisee added to addition queue.');
      }
    },
    removeAppraisee(appraisee) {
      if (this.autoUpdate) {
        // If autoUpdate is true, send the delete request immediately
        this.deleteAppraisee(appraisee.id);
      } else {
        // Otherwise, queue the deletion
        this.queueDeletion(appraisee.id);
        this.$toast.info('Appraisee added to deletion queue.');
      }
    },
    async addAppraisee(appraisees) {
      try {
        await dynamic_axios.post('/appraisal/add_appraisee', {
          doc_no: this.appraiserFormData.id,
          user_id: 'currentUserId',
          appraisees: appraisees
        }, {
          apiName: 'companyName'
        });
        this.$toast.success('Appraisee added successfully!');
      } catch (error) {
        console.error('Failed to add appraisees:', error);
        this.$toast.error('Failed to add appraisees.');
      }
    },
    async deleteAppraisee(appraiseeId) {
      try {
        await dynamic_axios.post('/delete_appraisee', {
          user_id: 'currentUserId',
          appraisee_ids: [appraiseeId]
        }, {
          apiName: 'companyName'
        });
        this.$toast.success('Appraisee deleted successfully!');
      } catch (error) {
        console.error('Failed to delete appraisee:', error);
        this.$toast.error('Failed to delete appraisee.');
      }
    },
    async submitChanges() {
      try {
        if (this.pendingAdditions.length > 0) {
          await this.submitAdditions();
        }
        if (this.pendingDeletions.length > 0) {
          await this.submitDeletions();
        }
        this.pendingAdditions = [];
        this.pendingDeletions = [];
        this.$toast.info('All changes submitted successfully!');
      } catch (error) {
        console.error('Failed to submit changes:', error);
        this.$toast.warning('Failed to submit some or all changes.');
      }
    },
    async submitAdditions() {
      try {
        await dynamic_axios.post('/appraisal/add_appraisee', {
          doc_no: this.appraiserFormData.id,
          user_id: 'currentUserId',
          appraisees: this.pendingAdditions
        }, {
          apiName: 'companyName'
        });
        this.$toast.success('Batch appraisee addition successful!');
      } catch (error) {
        console.error('Failed to add appraisees in batch:', error);
        this.$toast.error('Batch addition failed.');
      }
    },
    async submitDeletions() {
      try {
        await dynamic_axios.post('/delete_appraisee', {
          user_id: 'currentUserId',
          appraisee_ids: this.pendingDeletions
        }, {
          apiName: 'companyName'
        });
        this.$toast.success('Batch appraisee deletion successful!');
      } catch (error) {
        console.error('Failed to delete appraisees in batch:', error);
        this.$toast.error('Batch deletion failed.');
      }
    },
  },
  mounted() {    
    this.getAllEmployees();
  },  
};
</script>